import { createTheme as MUICreateTheme, shouldSkipGeneratingVar as muiShouldSkipGeneratingVar, } from "@mui/material/styles";
import variables from "../../assets/styles/variablesExport.module.scss";
import variablesDark from "../../assets/styles/variablesExportDark.module.scss";
import { cssVars } from "./cssVars";
import componentStyleOverrides from "./overrides";
import { darkPalette, lightPalette } from "./palette";
import Shadows from "./shadows";
import Shape from "./shape";
import Typography from "./typography";
export const createTheme = () => {
    const themeOption = {
        variables,
    };
    const themeShape = Shape(themeOption);
    const themeTypography = Typography(themeOption);
    const themeShadows = Shadows();
    const themeOptions = {
        direction: "ltr",
        cssVariables: {
            colorSchemeSelector: "data-theme",
            shouldSkipGeneratingVar: (keys) => keys[0] === "variables" || muiShouldSkipGeneratingVar(keys),
        },
        spacing: parseInt(variables.spacing_base, 10),
        shape: themeShape,
        colorSchemes: {
            light: { palette: lightPalette(themeOption) },
            dark: { palette: darkPalette({ variables: variablesDark }) },
        },
        defaultColorScheme: "light",
        typography: themeTypography,
        shadows: themeShadows,
        variables,
    };
    const theme = MUICreateTheme(themeOptions);
    theme.components = componentStyleOverrides({ variables: cssVars });
    return theme;
};
export default createTheme;
//# sourceMappingURL=index.js.map